import {initLogin} from './forms/login';
import {initRestore} from './forms/restore';
import {initRestoreAction} from './forms/restoreAction';
import {initDisallowProducts} from './forms/disallowProducts';
import {initExcludeFilters} from './forms/excludeFilters';
import {initRegister} from './forms/userForm/register';
import {initPersonal} from './forms/userForm/personal';
import {initClientParams} from './forms/userForm/clientParams';
import {initRebuildProgramms} from './forms/userForm/rebuildProgramms';
import {initBalancePopover} from './forms/balancePopover';
import {initLoadReplacements} from './forms/loadReplacements';

import {initCompoundChart} from './charts/compound.js'
import {initHistoryChart} from './charts/history.js'
import { initChangeEmail } from './forms/changeEmail';
import { initCreatePayment } from './forms/createPayment';
import { initReplaceRecipe } from './forms/replaceRecipe';
import { initClientMenu } from './forms/clientMenu';
import { initDragScroll } from './forms/dragScroll';
import { initTalkMe } from './talkme';
import { initInvite } from './forms/invite';
import { initWeekSetup } from './forms/weekSetup';
import { initShoppingList } from './forms/shoppingList';
import { initRecommendations } from './forms/recommendations';
import { initNavFeedback } from './forms/navFeedback';
import { initPortions } from './forms/portions';
import { initBalance } from './forms/balance';

export class Client {
    constructor($, apiClient) {
        this.$ = $;
        this.apiClient = apiClient;
    }

    /**
     * Запуск модулей страницы.
     *
     * Каждый модуль в своей попытке: раньше они шли подряд одним
     * списком, и первая же ошибка обрывала цепочку — всё, что ниже,
     * молча не запускалось. Хуже всего доставалось последним
     * в списке: передача данных в чат стояла в самом конце, и падение
     * любого модуля выше лишало оператора карточки клиента, не оставив
     * следа (разбор 17.10).
     *
     * Имя модуля идёт в консоль вместе с ошибкой: без него в собранном
     * бандле непонятно, что именно упало.
     */
    initialize() {
        // Чат первым: он ни от чего не зависит, а оператору важнее
        // всего знать, кто пишет.
        const steps = [
            ['чат: данные клиента', () => initTalkMe(this.$, this.apiClient)],
            ['график состава', () => initCompoundChart(this.$)],
            ['график веса', () => initHistoryChart(this.$)],
            ['вход', () => initLogin(this.$, this.apiClient)],
            ['восстановление пароля', () => initRestore(this.$, this.apiClient)],
            ['смена почты', () => initChangeEmail(this.$, this.apiClient)],
            ['оплата', () => initCreatePayment(this.$, this.apiClient)],
            ['сброс пароля', () => initRestoreAction(this.$, this.apiClient)],
            ['исключения продуктов', () => initDisallowProducts(this.$, this.apiClient)],
            ['фильтры исключений', () => initExcludeFilters()],
            ['регистрация', () => initRegister(this.$, this.apiClient)],
            ['свои параметры', () => initPersonal(this.$, this.apiClient)],
            ['параметры клиента', () => initClientParams(this.$, this.apiClient)],
            ['виджет программы', () => initRebuildProgramms(this.$, this.apiClient)],
            ['поповер баланса', () => initBalancePopover()],
            ['загрузка замен', () => initLoadReplacements(this.$, this.apiClient)],
            ['замена рецепта', () => initReplaceRecipe(this.$, this.apiClient)],
            ['меню клиента', () => initClientMenu()],
            ['перетаскивание', () => initDragScroll()],
            ['приглашение', () => initInvite()],
            ['настройка недели', () => initWeekSetup(this.$, this.apiClient)],
            ['список покупок', () => initShoppingList(this.$, this.apiClient)],
            ['рекомендации', () => initRecommendations(this.$, this.apiClient)],
            ['отклик на переход', () => initNavFeedback()],
            ['количество порций', () => initPortions(this.$)],
            ['баланс', () => initBalance(this.$, this.apiClient)],
        ];
        for (const [name, run] of steps) {
            try {
                run();
            } catch (error) {
                console.error(`Модуль «${name}» не запустился`, error);
            }
        }
    }
}
